import { co2Service } from "../services";
import { etaService } from "../services";
import { googleMapsService } from "../services";
import { priceService } from "../services/priceService";
import { bookingService } from "../services/bookingService";
import { tools } from "../helpers";
import { dictionary } from "../helpers";

const getInitialState = () => {
  return JSON.parse(JSON.stringify(initialState));
};

const initialGoods = {
  id: 1,
  cll: "1,00",
  weight: "0,00",
  description: "",
  unit_type: null,
  length: 0,
  width: 0,
  height: 0,
  cbm: "0,00",
  pallet_spaces: "0,00",
  reference: "",
  pipes: false,
  slv: false,
  adr: false,
  un_no: "",
  packing_group: ""
};

const initialVehicleType = {
  id: "",
  name: "",
  pallet_spaces: 0,
  loading_height: 0,
  loading_width: 0,
  loading_length: 0,
  max_weight: 0,
  lift: null,
  pipes: null,
  external_key: ""
};

const initialPrice = {
  loading: false,
  applicablefortimeflex: false,
  currency: "",
  pricestatus: "",
  pricetype: "",
  totalprice: 0.0,
  transportprice: null,
  waitingprice: null,
  totalchargeprice: 0.0,
  chargedetails: []
};

const initialState = {
  valid: true,
  valid_for_price: false,
  errors: [],
  earliest_posible_pickup: null,
  bookingForDisplay: null,
  displayBookingDialog: false,
  load_progress: 100,
  display_vehicle_type: true,
  display_timewindow: true,
  display_extra_info: false,
  data: {
    account: {
      id: "",
      name: "",
      address: "",
      zip: "",
      city: "",
      country: "",
      lon: "",
      lat: ""
    },
    pickup: {
      address: {
        name: "",
        address: "",
        address2: "",
        zip: "",
        city: "",
        country: "DK",
        lon: "",
        lat: ""
      },
      contact: {
        name: "",
        phone: ""
      },
      timewindow: {
        from: {
          date: "",
          time: "",
          to_string: ""
        },
        to: {
          date: "",
          time: "",
          to_string: ""
        }
      },
      route: {
        distance_meters: 0,
        drivetime_seconds: 0
      }
    },
    delivery: {
      address: {
        name: "",
        address: "",
        address2: "",
        zip: "",
        city: "",
        country: "DK",
        lon: "",
        lat: ""
      },
      contact: {
        name: "",
        phone: ""
      },
      timewindow: {
        from: {
          date: "",
          time: "",
          to_string: ""
        },
        to: {
          date: "",
          time: "",
          to_string: ""
        }
      },
      route: {
        distance_meters: 0,
        drivetime_seconds: 0
      }
    },
    vehicle_type: Object.assign({}, initialVehicleType), //clone
    goods: [
      Object.assign({}, initialGoods) //clone
    ],
    reference_1: "",
    reference_2: "",
    remark: "",
    notification: {
      notification_to_booker: true,
      booker_email: "",
      booker_notification_types: ["POP", "POD"],
      notification_to_alt: false,
      alt_email: "",
      alt_notification_types: []
    },
    insurance: false,
    insurance_amount: "0,00",
    photo_documentation: false,
    allow_no_signature: false,
    price: Object.assign({}, initialPrice) //clone
  }
};

export const booking = {
  namespaced: true,
  state: getInitialState(),
  actions: {
    validate() {
      // reset earliest possible
      let now = new Date();
      now.setSeconds(0); //reset seconds
      now.setMilliseconds(0); //reset milliseconds
      this.commit("booking/setEarliestPosiblePickup", new Date(now.getTime())); //not earlier than now!

      this.state.booking.valid = true;
      this.state.booking.errors = [];
      if (!this.state.booking.data) {
        this.state.booking.valid = false;
        return;
      }
      // account
      if (
        !this.state.booking.data.account ||
        !this.state.booking.data.account.id
      ) {
        this.state.booking.errors.push(dictionary.errors.account);
      }
      if (this.state.booking.errors.length) {
        this.state.booking.valid = false;
        return;
      }
      // pickup address
      if (
        !this.state.booking.data.pickup ||
        !this.state.booking.data.pickup.address
      ) {
        this.state.booking.valid = false;
        return;
      }
      if (!this.state.booking.data.pickup.address.name) {
        this.state.booking.errors.push(dictionary.errors.pickup.address.name);
      }
      if (
        !this.state.booking.data.pickup.address.address ||
        !this.state.booking.data.pickup.address.zip ||
        !this.state.booking.data.pickup.address.country
      ) {
        if (
          !this.state.booking.data.pickup.address.address &&
          !this.state.booking.data.pickup.address.zip
        ) {
          this.state.booking.errors.push(
            dictionary.errors.pickup.address.address
          );
        }
      }
      if (this.state.booking.errors.length) {
        this.state.booking.valid = false;
        return;
      }
      if (
        !this.state.booking.data.pickup.address.lat ||
        !this.state.booking.data.pickup.address.lon
      ) {
        this.state.booking.errors.push(
          dictionary.errors.pickup.address.coordinates
        );
      }
      if (this.state.booking.errors.length) {
        this.state.booking.valid = false;
        return;
      }

      if (
        !this.getters["user/hideContact"] &&
        !this.getters["user/allowEmptyContactPerson"] &&
        this.state.booking.data.pickup &&
        this.state.booking.data.pickup.contact &&
        !this.state.booking.data.pickup.contact.name
      ) {
        this.state.booking.errors.push(dictionary.errors.pickup.contact.name);
      }
      if (
        !this.getters["user/hideContact"] &&
        !this.getters["user/allowEmptyContactPhone"] &&
        this.state.booking.data.pickup &&
        this.state.booking.data.pickup.contact &&
        !this.state.booking.data.pickup.contact.phone
      ) {
        this.state.booking.errors.push(dictionary.errors.pickup.contact.phone);
      }
      if (this.state.booking.errors.length) {
        this.state.booking.valid = false;
        return;
      }

      // delivery address
      if (
        !this.state.booking.data.delivery ||
        !this.state.booking.data.delivery.address
      ) {
        this.state.booking.valid = false;
        return;
      }
      if (!this.state.booking.data.delivery.address.name) {
        this.state.booking.errors.push(dictionary.errors.delivery.address.name);
      }
      if (
        !this.state.booking.data.delivery.address.address ||
        !this.state.booking.data.delivery.address.zip ||
        !this.state.booking.data.delivery.address.country
      ) {
        if (
          !this.state.booking.data.delivery.address.address &&
          !this.state.booking.data.delivery.address.zip
        ) {
          this.state.booking.errors.push(
            dictionary.errors.delivery.address.address
          );
        }
      }
      if (this.state.booking.errors.length) {
        this.state.booking.valid = false;
        return;
      }
      if (
        !this.state.booking.data.delivery.address.lat ||
        !this.state.booking.data.delivery.address.lon
      ) {
        this.state.booking.errors.push(
          dictionary.errors.delivery.address.coordinates
        );
      }
      if (this.state.booking.errors.length) {
        this.state.booking.valid = false;
        return;
      }

      if (
        !this.getters["user/hideContact"] &&
        !this.getters["user/allowEmptyContactPerson"] &&
        this.state.booking.data.delivery &&
        this.state.booking.data.delivery.contact &&
        !this.state.booking.data.delivery.contact.name
      ) {
        this.state.booking.errors.push(dictionary.errors.delivery.contact.name);
      }
      if (
        !this.getters["user/hideContact"] &&
        !this.getters["user/allowEmptyContactPhone"] &&
        this.state.booking.data.delivery &&
        this.state.booking.data.delivery.contact &&
        !this.state.booking.data.delivery.contact.phone
      ) {
        this.state.booking.errors.push(
          dictionary.errors.delivery.contact.phone
        );
      }
      if (this.state.booking.errors.length) {
        this.state.booking.valid = false;
        return;
      }

      // goods
      if (
        !this.state.booking.data.goods ||
        !Array.isArray(this.state.booking.data.goods) ||
        !this.state.booking.data.goods.length
      ) {
        this.state.booking.errors.push(dictionary.errors.goods.missing);
      }
      if (this.state.booking.errors.length) {
        this.state.booking.valid = false;
        return;
      }
      this.state.booking.data.goods.forEach(goodsItem => {
        if (!goodsItem) {
          this.state.booking.errors.push(dictionary.errors.goods.missing);
        }
        if (this.state.booking.errors.length) {
          this.state.booking.valid = false;
          return;
        }
        if (!goodsItem.cll || tools.parseDouble(goodsItem.cll) === 0.0) {
          this.state.booking.errors.push(dictionary.errors.goods.cll);
        }
        if (!goodsItem.description) {
          this.state.booking.errors.push(dictionary.errors.goods.description);
        }
        if (!goodsItem.weight || tools.parseDouble(goodsItem.weight) === 0.0) {
          this.state.booking.errors.push(dictionary.errors.goods.weight);
        }
        if (goodsItem.pipes && tools.parseDouble(goodsItem.length) === 0.0) {
          this.state.booking.errors.push(dictionary.errors.goods.pipes);
        }
        if (goodsItem.adr && !goodsItem.un_no) {
          this.state.booking.errors.push(dictionary.errors.goods.adr);
        }
        if (goodsItem.adr && !goodsItem.packing_group) {
          this.state.booking.errors.push(dictionary.errors.goods.packing_group);
        }
        if (
          !this.getters["user/hideGoodsReference"] &&
          !this.getters["user/allowEmptyGoodsReference"] &&
          !goodsItem.reference
        ) {
          this.state.booking.errors.push(dictionary.errors.goods.reference);
        }
        if (this.state.booking.errors.length) {
          this.state.booking.valid = false;
          return;
        }
      });
      if (this.state.booking.errors.length) {
        this.state.booking.valid = false;
        return;
      }
      // vehicletype
      if (
        !this.state.booking.data.vehicle_type ||
        !this.state.booking.data.vehicle_type.external_key
      ) {
        this.state.booking.errors.push(dictionary.errors.vehicle_type.missing);
      }
      if (this.state.booking.errors.length) {
        this.state.booking.valid = false;
        return;
      }
      //check for overload
      let maxWeight = tools.parseDouble(0.0);
      let totalWeight = tools.parseDouble(0.0);
      let totalPalletSpaces = tools.parseDouble(0.0);
      let hasPipes = false;
      let pipesLength = 0;
      this.state.booking.data.goods.forEach(goodsItem => {
        if (goodsItem) {
          maxWeight =
            tools.parseDouble(goodsItem.weight) > maxWeight
              ? tools.parseDouble(goodsItem.weight)
              : maxWeight;
          totalWeight += tools.parseDouble(goodsItem.weight);
          totalPalletSpaces += tools.parseDouble(goodsItem.pallet_spaces);
          if (goodsItem.pipes) {
            hasPipes = true;
            pipesLength = Math.max(pipesLength, goodsItem.length);
          }
        }
      });
      if (
        tools.parseDouble(this.state.booking.data.vehicle_type.max_weight) <
        totalWeight
      ) {
        this.state.booking.errors.push(
          dictionary.errors.vehicle_type.overload.weight
        );
      }
      if (
        this.state.booking.data.vehicle_type.lift &&
        tools.parseDouble(
          this.state.booking.data.vehicle_type.lift.max_weight
        ) < maxWeight
      ) {
        this.state.booking.errors.push(
          dictionary.errors.vehicle_type.overload.weight_lift
        );
      }
      if (
        tools.parseDouble(this.state.booking.data.vehicle_type.pallet_spaces) <
        totalPalletSpaces
      ) {
        this.state.booking.errors.push(
          dictionary.errors.vehicle_type.overload.pallet_spaces
        );
      }
      if (!this.state.booking.data.vehicle_type.pipes && hasPipes) {
        this.state.booking.errors.push(
          dictionary.errors.vehicle_type.overload.pipes
        );
      }
      if (
        this.state.booking.data.vehicle_type.pipes &&
        hasPipes &&
        this.state.booking.data.vehicle_type.pipes.max_length < pipesLength
      ) {
        this.state.booking.errors.push(
          dictionary.errors.vehicle_type.overload.pipes_length
        );
      }
      // timestamps
      if (
        !this.state.booking.data.pickup.timewindow ||
        !this.state.booking.data.pickup.timewindow.from ||
        !this.state.booking.data.pickup.timewindow.from.date ||
        !this.state.booking.data.pickup.timewindow.from.time
      ) {
        this.state.booking.errors.push(
          dictionary.errors.pickup.timewindow.from.date
        );
      }
      if (!this.state.booking.data.pickup.timewindow.from.time) {
        this.state.booking.errors.push(
          dictionary.errors.pickup.timewindow.from.time
        );
      }
      if (this.state.booking.errors.length) {
        this.state.booking.valid = false;
        return;
      }
      //check if pickup from is too early
      let d = new Date(this.state.booking.data.pickup.timewindow.from.date);
      const hoursMinutes = tools.splitHoursMinutes(
        this.state.booking.data.pickup.timewindow.from.time
      );
      d.setHours(hoursMinutes.hours, hoursMinutes.minutes, 0, 0);
      // if 15plt; add 60 min
      const fromTimeBufferInMinutes =
        this.state.booking.data.vehicle_type.external_key == "15PLT" ? 60 : 0;

      if (
        this.state.booking.earliest_posible_pickup.getTime() +
          fromTimeBufferInMinutes * 60 * 1000 >
        d.getTime()
      ) {
        this.state.booking.errors.push(
          dictionary.errors.pickup.timewindow.from.not_possible
        );
      }
      if (this.state.booking.errors.length) {
        this.state.booking.valid = false;
        return;
      }
      if (
        !this.state.booking.data.pickup.timewindow.to ||
        !this.state.booking.data.pickup.timewindow.to.date ||
        !this.state.booking.data.pickup.timewindow.to.time
      ) {
        this.state.booking.errors.push(
          dictionary.errors.pickup.timewindow.to.time
        );
      }
      if (this.state.booking.errors.length) {
        this.state.booking.valid = false;
        return;
      }
      // extra info
      const allowEmptyReference1 = this.getters["user/allowEmptyReference1"];
      if (!allowEmptyReference1 && !this.state.booking.data.reference_1) {
        this.state.booking.errors.push(dictionary.errors.reference_1);
      }
      if (
        !this.getters["user/hideBookingNotifications"] &&
        this.state.booking.data.notification.notification_to_booker &&
        !this.state.booking.data.notification.booker_email
      ) {
        this.state.booking.errors.push(
          dictionary.errors.notification.booker_email
        );
      }
      if (
        this.state.booking.data.insurance &&
        tools.parseDouble(this.state.booking.data.insurance_amount) === 0.0
      ) {
        this.state.booking.errors.push(dictionary.errors.insurance.amount);
      }
      if (this.state.booking.errors.length) {
        this.state.booking.valid = false;
        this.state.booking.display_extra_info = true;
        return;
      }
    },
    validateForPrice() {
      const bookingType = this.getters["user/bookingType"];
      if (bookingType === dictionary.constants.booking_types.distribution) {
        this.state.booking.valid_for_price = false;
        return;
      }
      this.state.booking.valid_for_price = true;
      if (!this.state.booking.data) {
        this.state.booking.valid_for_price = false;
        return;
      }
      if (
        !this.state.booking.data.account ||
        !this.state.booking.data.account.id
      ) {
        this.state.booking.valid_for_price = false;
        return;
      }
      if (
        !this.state.booking.data.pickup ||
        !this.state.booking.data.pickup.address
      ) {
        this.state.booking.valid_for_price = false;
        return;
      }
      if (
        !this.state.booking.data.pickup.address.address ||
        !this.state.booking.data.pickup.address.zip ||
        !this.state.booking.data.pickup.address.country
      ) {
        this.state.booking.valid_for_price = false;
        return;
      }
      if (
        !this.state.booking.data.delivery ||
        !this.state.booking.data.delivery.address
      ) {
        this.state.booking.valid_for_price = false;
        return;
      }
      if (
        !this.state.booking.data.delivery.address.address ||
        !this.state.booking.data.delivery.address.zip ||
        !this.state.booking.data.delivery.address.country
      ) {
        this.state.booking.valid_for_price = false;
        return;
      }
      if (
        !this.state.booking.data.pickup.timewindow ||
        !this.state.booking.data.pickup.timewindow.from ||
        !this.state.booking.data.pickup.timewindow.from.date ||
        !this.state.booking.data.pickup.timewindow.from.time ||
        !this.state.booking.data.pickup.timewindow.from.time
      ) {
        this.state.booking.valid_for_price = false;
        return;
      }
      if (
        !this.state.booking.data.pickup.timewindow.to ||
        !this.state.booking.data.pickup.timewindow.to.date ||
        !this.state.booking.data.pickup.timewindow.to.time
      ) {
        this.state.booking.valid_for_price = false;
        return;
      }
      if (
        !this.state.booking.data.vehicle_type ||
        !this.state.booking.data.vehicle_type.external_key
      ) {
        this.state.booking.valid_for_price = false;
        return;
      }
      if (
        !this.state.booking.data.goods ||
        !Array.isArray(this.state.booking.data.goods) ||
        !this.state.booking.data.goods.length
      ) {
        this.state.booking.valid_for_price = false;
        return;
      }
      this.state.booking.data.goods.forEach(goodsItem => {
        if (!goodsItem) {
          this.state.booking.valid_for_price = false;
          return;
        }
        if (!goodsItem.weight || tools.parseDouble(goodsItem.weight) === 0.0) {
          this.state.booking.valid_for_price = false;
          return;
        }
      });
    },
    calculateCO2Footprint(
      context,
      { customerIds, fromDate, toDate, bookingId }
    ) {
      return new Promise((resolve, reject) => {
        co2Service
          .calculateCO2Footprint(customerIds, fromDate, toDate, bookingId)
          .then(
            response => {
              resolve(response);
            },
            error => {
              reject(error);
            }
          );
      });
    },
    getPickupTimeWindows(
      context,
      { accountId, pickupZip, deliveryZip, pickupFromDate, pickupFromTime }
    ) {
      return new Promise((resolve, reject) => {
        etaService
          .getPickupTimeWindows(
            accountId,
            pickupZip,
            deliveryZip,
            pickupFromDate,
            pickupFromTime
          )
          .then(
            response => {
              resolve(response);
            },
            error => {
              reject(error);
            }
          );
      });
    },
    calculateETA(
      context,
      {
        accountId,
        pickupZip,
        deliveryZip,
        pickupFromDate,
        pickupFromTime,
        pickupToDate,
        pickupToTime,
        stopDrivetimes
      }
    ) {
      return new Promise((resolve, reject) => {
        etaService
          .calculateETA(
            accountId,
            pickupZip,
            deliveryZip,
            pickupFromDate,
            pickupFromTime,
            pickupToDate,
            pickupToTime,
            stopDrivetimes
          )
          .then(
            response => {
              resolve(response);
            },
            error => {
              reject(error);
            }
          );
      });
    },
    lookupNames(context, { address }) {
      return new Promise((resolve, reject) => {
        bookingService.lookupNames(address).then(
          response => {
            resolve(response);
          },
          error => {
            reject(error);
          }
        );
      });
    },
    lookupAddresses(context, { address }) {
      return new Promise((resolve, reject) => {
        bookingService.lookupAddresses(address).then(
          response => {
            resolve(response);
          },
          error => {
            reject(error);
          }
        );
      });
    },
    loadMatchingTerminalAddress(
      context,
      { customerId, inboundOutboundType, address }
    ) {
      bookingService
        .loadMatchingTerminalAddress(customerId, inboundOutboundType, address)
        .then(
          response => {
            if (response) {
              const terminalAddress = {
                name: response.name,
                address: response.address,
                zip: response.zip,
                city: response.city,
                country: response.countryCode,
                lat: response.lat,
                lon: response.lon
              };

              if (
                inboundOutboundType ===
                dictionary.constants.terminal_address_types.inbound
              ) {
                this.commit("booking/updateDeliveryAddress", terminalAddress);
                this.commit(
                  "booking/updateDeliveryAddress2",
                  response.addressInfo
                );
              } else if (
                inboundOutboundType ===
                dictionary.constants.terminal_address_types.outbound
              ) {
                this.commit("booking/updatePickupAddress", terminalAddress);
                this.commit(
                  "booking/updatePickupAddress2",
                  response.addressInfo
                );
              }
            }
          },
          error => {
            console.error(error);
          }
        );
    },
    calculateRoute() {
      googleMapsService
        .calculateRoute(
          this.state.booking.data.pickup,
          this.state.booking.data.delivery
        )
        .then(
          response => {
            this.commit("booking/updateDeliveryRoute", {
              distance_meters: response.distance,
              drivetime_seconds: response.drivetime
            });
          },
          error => {
            console.error(error);
          }
        );
    },
    async calculatePrice() {
      this.commit("booking/updatePriceLoading", true);
      await this.dispatch("booking/validateForPrice");
      if (this.state.booking.data && this.state.booking.valid_for_price) {
        await priceService.calculatePrice(this.state.booking.data).then(
          response => {
            if (response != null && response.result != null) {
              this.commit("booking/updatePrice", response.result.price);
            }
          },
          error => {
            console.error(error);
          }
        );
      } else {
        this.commit("booking/updatePrice", Object.assign({}, initialPrice));
      }
      this.commit("booking/updatePriceLoading", false);
    },
    sendBooking() {
      return new Promise((resolve, reject) => {
        if (
          this.state.user.activeUser &&
          this.state.booking &&
          this.state.booking.valid
        ) {
          bookingService
            .sendBooking(this.state.booking.data, this.state.user.activeUser)
            .then(
              response => {
                resolve(response);
              },
              error => {
                reject(error);
              }
            );
        }
      });
    },
    searchBookings(context, { fromDate, toDate, reference, stopName }) {
      return new Promise((resolve, reject) => {
        bookingService
          .searchBookings(
            this.state.user.activeUser,
            fromDate,
            toDate,
            reference,
            stopName
          )
          .then(
            response => {
              resolve(response);
            },
            error => {
              reject(error);
            }
          );
      });
    },
    loadBookingEvents(context, bookingNo) {
      return new Promise((resolve, reject) => {
        bookingService
          .loadBookingEvents(this.state.user.activeUser, bookingNo)
          .then(
            response => {
              resolve(response);
            },
            error => {
              reject(error);
            }
          );
      });
    },
    uploadBookingExcel(context, orders) {
      this.commit("booking/updateLoadProgress", 0);
      var BreakException = {};
      try {
        return new Promise((resolve, reject) => {
          // console.log(order);

          let progress = 0;

          if (orders && orders.length > 0) {
            orders.forEach(order => {
              if (order) {
                if (this.state.user.activeUser) {
                  bookingService
                    .sendPickupDelivery(order, order.order.customerno)
                    .then(
                      () => {
                        progress++;

                        this.commit(
                          "booking/updateLoadProgress",
                          Math.round((progress / orders.length) * 100)
                        );
                      },
                      error => {
                        reject(error);
                      }
                    );
                }
              }
            });
          }
        });
      } catch (e) {
        if (e !== BreakException) throw e;
      }
      this.commit("booking/updateLoadProgress", 100);
    }
  },

  mutations: {
    setEarliestPosiblePickup(state, timestamp) {
      state.earliest_posible_pickup = timestamp;
    },
    resetBooking(state) {
      Object.assign(state, getInitialState());

      let d = new Date();
      d.setSeconds(0); //reset seconds
      d.setMilliseconds(0); //reset milliseconds
      this.commit(
        "booking/setEarliestPosiblePickup",
        new Date(d.getTime() + 5 * 60 * 1000)
      ); //add 5 min.

      const dateTime = tools.splitDateTime(
        this.state.booking.earliest_posible_pickup
      );

      this.commit("booking/updatePickupTimewindowFromDate", dateTime.date);
      this.commit("booking/updatePickupTimewindowFromTime", dateTime.time);

      this.state.booking.display_timewindow =
        this.getters["user/bookingType"] ==
        dictionary.constants.booking_types.courier; //default hide timewindows for distribution

      if (this.state.user.activeUser) {
        //set defaultName before account; account will override defaultName
        const defaultName = this.getters["user/defaultName"];

        if (defaultName) {
          this.commit("booking/updatePickupName", defaultName);
          this.commit("booking/updateDeliveryName", defaultName);
        }

        const account = this.state.user.activeUser.default_account;

        if (account) {
          this.commit("booking/updateAccount", account);
        }

        let vehicleType = null;

        const defaultVehicleType = this.getters["user/defaultVehilceType"];
        const vehicleTypes = this.getters["user/vehicleTypes"];

        if (defaultVehicleType) {
          vehicleTypes.forEach(thisVehicleType => {
            if (
              thisVehicleType &&
              thisVehicleType.external_key === defaultVehicleType
            ) {
              vehicleType = thisVehicleType;
            }
          });
        }

        if (vehicleType) {
          this.commit("booking/updateVehicleType", vehicleType);
        }

        //if distribution and default vehicle type, then collapse vehicletypes
        this.state.booking.display_vehicle_type =
          this.getters["user/bookingType"] ==
            dictionary.constants.booking_types.distribution &&
          this.state.booking.data.vehicle_type &&
          this.state.booking.data.vehicle_type.external_key
            ? false
            : true;

        const notificatioToBooker = this.getters["user/notificationToBooker"];
        this.commit("booking/updateNotificationToBooker", notificatioToBooker);

        const photoDocumentation = this.getters["user/photoDocumentation"];
        this.commit("booking/updatePhotoDocumentation", photoDocumentation);

        const allowNoSignature = this.getters["user/allowNoSignature"];
        this.commit("booking/updateAllowNoSignature", allowNoSignature);

        // if reference is not allowed empty; default open extra info section
        const allowEmptyReference1 = this.getters["user/allowEmptyReference1"];
        if (!allowEmptyReference1) {
          this.state.booking.display_extra_info = true;
        }
      }
    },
    //from history booking object
    setBooking(state, booking) {
      const customer = this.state.user.activeUser.accounts.filter(
        account => account.id == booking.customerno
      );

      let account = Object.assign({}, state.data.account);

      if (customer && customer.length > 0 && customer[0]) {
        account.id = customer[0].id;
        account.name = customer[0].name;
        account.address = customer[0].address;
        account.zip = customer[0].zip;
        account.city = customer[0].city;
        account.country = customer[0].country_code;
        account.lat = customer[0].lat;
        account.lon = customer[0].lon;
      }

      this.commit("booking/updateAccount", account);

      const pickupStop =
        booking.stops && booking.stops.length > 0 ? booking.stops[0] : null;

      let pickup = Object.assign({}, state.data.pickup);

      if (pickupStop) {
        pickup.address.name = pickupStop.address.name1;
        pickup.address.address = pickupStop.address.address1;
        pickup.address.address2 = pickupStop.instructions;
        pickup.address.zip = pickupStop.address.zip;
        pickup.address.city = pickupStop.address.city;
        pickup.address.country = pickupStop.address.countrycode;
        pickup.address.lon = pickupStop.address.coordinates.lng;
        pickup.address.lat = pickupStop.address.coordinates.lat;
        pickup.contact.name = pickupStop.contactname;
        pickup.contact.phone = pickupStop.contactphone;
      }

      this.commit("booking/updatePickup", pickup);

      const deliveryStop =
        booking.stops && booking.stops.length > 0
          ? booking.stops[booking.stops.length - 1]
          : null;

      let delivery = Object.assign({}, state.data.delivery);

      if (deliveryStop) {
        delivery.address.name = deliveryStop.address.name1;
        delivery.address.address = deliveryStop.address.address1;
        delivery.address.address2 = deliveryStop.instructions;
        delivery.address.zip = deliveryStop.address.zip;
        delivery.address.city = deliveryStop.address.city;
        delivery.address.country = deliveryStop.address.countrycode;
        delivery.address.lon = deliveryStop.address.coordinates.lng;
        delivery.address.lat = deliveryStop.address.coordinates.lat;
        delivery.contact.name = deliveryStop.contactname;
        delivery.contact.phone = deliveryStop.contactphone;
      }

      this.commit("booking/updateDelivery", delivery);

      const vehicleTypes = this.getters["user/vehicleTypes"];

      const carType = vehicleTypes.filter(
        vehicleType => vehicleType.external_key == booking.cartype
      );

      let vehicleType = Object.assign({}, state.data.vehicle_type);

      if (carType && carType.length > 0 && carType[0]) {
        vehicleType = Object.assign({}, carType[0]);
      }

      this.commit("booking/updateVehicleType", vehicleType);

      let goods = [];

      booking.goods.forEach(bookingGoods => {
        let goodsItem = Object.assign({}, initialGoods);

        goodsItem.cll = tools.parseDoubleToString(
          tools.parseDouble(bookingGoods.cll)
        );
        goodsItem.weight = tools.parseDoubleToString(
          tools.parseDouble(bookingGoods.grossweight)
        );
        goodsItem.description = bookingGoods.description;
        if (bookingGoods.unit_type) {
          goodsItem.unit_type = {
            name: bookingGoods.unit_type.name,
            fms_reference: bookingGoods.unit_type.fms_reference,
            external_key: bookingGoods.unit_type.external_key,
            calculation_factor: bookingGoods.unit_type.calculation_factor
          };
        }
        goodsItem.length = bookingGoods.length;
        goodsItem.width = bookingGoods.width;
        goodsItem.height = bookingGoods.height;
        goodsItem.cbm = tools.parseDoubleToString(
          tools.parseDouble(bookingGoods.cbm)
        );
        goodsItem.pallet_spaces = tools.parseDoubleToString(
          tools.parseDouble(bookingGoods.pallet_spaces)
        );
        goodsItem.reference = bookingGoods.reference;
        goodsItem.pipes = bookingGoods.pipes;
        goodsItem.slv = bookingGoods.slv;
        goodsItem.adr = bookingGoods.adr;
        goodsItem.un_no = bookingGoods.unno;
        goodsItem.packing_group = bookingGoods.packinggroup;

        goods.push(goodsItem);
      });

      this.commit("booking/updateGoods", goods);

      state.data.reference_1 = booking.reference;
      state.data.remark = booking.comment;

      state.data.notification.notification_to_booker = booking.notificationemail
        ? true
        : false;
      state.data.notification.booker_email = booking.notificationemail;

      state.data.insurance_amount = booking.insuranceamount;
      state.data.insurance = booking.insuranceamount ? true : false;
      state.data.photo_documentation = booking.photodocumentation;
      state.data.allow_no_signature = booking.allownosignature;

      //copying price doesn't make sence!

      this.dispatch("booking/calculateRoute");
    },
    setBookingForDisplay(state, booking) {
      state.bookingForDisplay = booking;
    },
    setDisplayBookingDialog(state, display) {
      state.displayBookingDialog = display;
    },
    updateAccount(state, payload) {
      state.data.account.id = payload.id;
      state.data.account.name = payload.name;
      state.data.account.address = payload.address;
      state.data.account.zip = payload.zip;
      state.data.account.city = payload.city;
      state.data.account.country = payload.country_code;
      state.data.account.lon = payload.lon;
      state.data.account.lat = payload.lat;

      //check if account address should be used at any stop

      const useOwnAddressAs = this.getters["user/useOwnAddressAs"];

      if (useOwnAddressAs) {
        if (useOwnAddressAs === dictionary.constants.address_types.pickup) {
          this.commit("booking/updatePickupAddress", state.data.account);
          this.commit("booking/updatePickupName", state.data.account.name);
        } else if (
          useOwnAddressAs === dictionary.constants.address_types.delivery
        ) {
          this.commit("booking/updateDeliveryAddress", state.data.account);
          this.commit("booking/updateDeliveryName", state.data.account.name);
        }
      }
    },
    updatePickup(state, pickup) {
      state.data.pickup = pickup;
    },
    clearPickupAddress(state) {
      state.data.pickup.address.address = "";
      state.data.pickup.address.zip = "";
      state.data.pickup.address.city = "";
      state.data.pickup.address.lat = "";
      state.data.pickup.address.lon = "";
    },
    updatePickupAddress(state, address) {
      state.data.pickup.address.address = address.address;
      state.data.pickup.address.zip = address.zip;
      state.data.pickup.address.city = address.city;
      if (
        address.country &&
        state.data.pickup.address.country != address.country
      ) {
        state.data.pickup.address.country = address.country;
      }
      state.data.pickup.address.lat = address.lat;
      state.data.pickup.address.lon = address.lon;
    },
    updatePickupCountry(state, country) {
      state.data.pickup.address.country = country;
    },
    updatePickupName(state, name) {
      state.data.pickup.address.name = name;
    },
    updatePickupAddress2(state, address) {
      state.data.pickup.address.address2 = address;
    },
    updatePickupContactName(state, name) {
      state.data.pickup.contact.name = name;
    },
    updatePickupContactPhone(state, phone) {
      state.data.pickup.contact.phone = phone;
    },
    updatePickupTimewindowFromDate(state, date) {
      state.data.pickup.timewindow.from.date = date;
    },
    updatePickupTimewindowFromTime(state, time) {
      state.data.pickup.timewindow.from.time = time;
    },
    updatePickupTimewindowTo(state, to) {
      state.data.pickup.timewindow.to = to;
    },
    updateDelivery(state, delivery) {
      state.data.delivery = delivery;
    },
    clearDeliveryAddress(state) {
      state.data.delivery.address.address = "";
      state.data.delivery.address.zip = "";
      state.data.delivery.address.city = "";
      state.data.delivery.address.lat = "";
      state.data.delivery.address.lon = "";
    },
    updateDeliveryAddress(state, address) {
      state.data.delivery.address.address = address.address;
      state.data.delivery.address.zip = address.zip;
      state.data.delivery.address.city = address.city;
      if (
        address.country &&
        state.data.delivery.address.country != address.country
      ) {
        state.data.delivery.address.country = address.country;
      }
      state.data.delivery.address.lat = address.lat;
      state.data.delivery.address.lon = address.lon;
    },
    updateDeliveryCountry(state, country) {
      state.data.delivery.address.country = country;
    },
    updateDeliveryName(state, name) {
      state.data.delivery.address.name = name;
    },
    updateDeliveryAddress2(state, address) {
      state.data.delivery.address.address2 = address;
    },
    updateDeliveryContactName(state, name) {
      state.data.delivery.contact.name = name;
    },
    updateDeliveryContactPhone(state, phone) {
      state.data.delivery.contact.phone = phone;
    },
    updateDeliveryTimewindow(state, timewindow) {
      state.data.delivery.timewindow = timewindow;
    },
    updateDeliveryRoute(state, route) {
      state.data.delivery.route = route;
    },
    updateVehicleType(state, vehicle_type) {
      if (vehicle_type) {
        state.data.vehicle_type.id = vehicle_type.id;
        state.data.vehicle_type.name = vehicle_type.name;
        state.data.vehicle_type.pallet_spaces = vehicle_type.pallet_spaces;
        state.data.vehicle_type.loading_height = vehicle_type.loading_height;
        state.data.vehicle_type.loading_width = vehicle_type.loading_width;
        state.data.vehicle_type.loading_length = vehicle_type.loading_length;
        state.data.vehicle_type.max_weight = vehicle_type.max_weight;
        state.data.vehicle_type.lift = vehicle_type.lift;
        state.data.vehicle_type.pipes = vehicle_type.pipes;
        state.data.vehicle_type.external_key = vehicle_type.external_key;
      } else {
        state.data.vehicle_type = Object.assign({}, initialVehicleType);
      }
    },
    updateGoods(state, goods_array) {
      state.data.goods = goods_array;
    },
    addGoods(state) {
      const newGoods = Object.assign({}, initialGoods); //clone
      newGoods.id = state.data.goods[state.data.goods.length - 1].id + 1;
      state.data.goods.push(newGoods);
    },
    removeGoods(state, goods_to_remove) {
      const index = state.data.goods.indexOf(goods_to_remove);
      if (index > -1) {
        state.data.goods.splice(index, 1);
      }
    },
    updateNotificationToBooker(state, enabled) {
      state.data.notification.booker_email = this.state.user.activeUser
        ? this.state.user.activeUser.email
        : "";
      if (enabled && state.data.notification.booker_email) {
        state.data.notification.notification_to_booker = true;
        state.data.notification.booker_notification_types = ["POP", "POD"];
      } else {
        state.data.notification.notification_to_booker = false;
        state.data.notification.booker_notification_types = [];
      }
    },
    updateNotificationToAlt(state, enabled) {
      state.data.notification.alt_email = "";
      if (enabled) {
        state.data.notification.notification_to_alt = true;
        state.data.notification.alt_notification_types = ["POP", "POD"];
      } else {
        state.data.notification.notification_to_alt = false;
        state.data.notification.alt_notification_types = [];
      }
    },
    updatePhotoDocumentation(state, selected) {
      state.data.photo_documentation = selected;
    },
    updateAllowNoSignature(state, selected) {
      state.data.allow_no_signature = selected;
    },
    updatePrice(state, price) {
      state.data.price = {};
      state.data.price = price;
    },
    updatePriceLoading(state, loading) {
      if (state.data.price) {
        state.data.price.loading = loading;
      }
    },
    updateLoadProgress(state, progress) {
      state.load_progress = progress;
    }
  },
  getters: {
    validatePickupCoordinates(state) {
      return (
        state.data.pickup.address.lon &&
        state.data.pickup.address.lon.length > 0 &&
        state.data.pickup.address.lat &&
        state.data.pickup.address.lat.length > 0
      );
    },
    validateDeliveryCoordinates(state) {
      return (
        state.data.delivery.address.lon &&
        state.data.delivery.address.lon.length > 0 &&
        state.data.delivery.address.lat &&
        state.data.delivery.address.lat.length > 0
      );
    }
  }
};
